export enum ProductsEndpoints {
  ROOT = '/products',
}
